define([], () => {
    /* eslint-disable */
    function initializeGtm(w,d,s,l,i){
        w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    };
    /* eslint-enable */

    return {
        $get: () => ({
            injectGTM(tagManagerId) {
                initializeGtm(window, document, 'script', 'dataLayer', tagManagerId);
            },
            pushToDataLayer(data) {
                if (Object.hasOwnProperty.call(window, 'dataLayer') && Array.isArray(window.dataLayer)) {
                    window.dataLayer.push(data);
                }
            },
        }),
    };
});



// WEBPACK FOOTER //
// ./app/js/portal/providers/GTMProvider.js